import GalleryDisplaySettingsModal from './GalleryDisplaySettingsModal';
import container from './GalleryDisplaySettingsModal.container';

export type { Props as GalleryDisplaySettingsModalProps } from './GalleryDisplaySettingsModal';

export { GalleryDisplaySettingsModal };
export default container(GalleryDisplaySettingsModal);